import type { Dictionary } from "./types";
import en from "./en.json";
import fr from "./fr.json";
import ja from "./ja.json";
import es from "./es.json";
import de from "./de.json";

const dictionaries: Record<string, Dictionary> = {
  en: en as Dictionary,
  fr: fr as Dictionary,
  ja: ja as Dictionary,
  es: es as Dictionary,
  de: de as Dictionary,
};

export function getStaticDictionary(locale: string): Dictionary {
  return dictionaries[locale] ?? dictionaries["en"];
}
